export default __webpack_public_path__ + "static/media/bg.99160e8a.jpg";